<template>
    <div class="topic-of-interest-home">
        <b-row
            no-gutters
            class="row-wrapper"
        >
            <b-col :cols="hasPropertyListings ? 7 : 12">
                <knowledge-asset-content
                    v-if="knowledgeAssetSearch.loaded && asset.exists"
                    :asset="asset"
                    article-content-over-image
                    :has-title-above="hasTitleAbove"
                    :event="landingPage.event"
                    :has-event="landingPage.hasEvent"
                />

                <knowledge-asset-loading v-if="!knowledgeAssetSearch.loaded" />
            </b-col>
            <b-col
                v-if="hasPropertyListings"
                cols="5"
                class="d-table map-col"
            >
                <topic-of-interest-home-map
                    v-if="!mapInitializing"
                    :landing-page="landingPage"
                />
            </b-col>
        </b-row>

        <home-footer
            :landing-page="landingPage"
            background-image-field="home.cover.publicStorageUrl"
        />
    </div>
</template>

<script>
    import "./TopicOfInterestHome.scss";
    import "./TopicOfInterestHome.sm.scss";
    import HomeFooter from "../../HomeFooter/HomeFooter";
    import AppResourceSearch from "@milestoneslabs/milestones-js-engine/src/Data/AppResourceSearch";
    import ApiFilter from "@milestoneslabs/milestones-js-engine/src/Api/ApiFilter";
    import KnowledgeAssetAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/KnowledgeAssetAppResource";
    import KnowledgeAssetContent from "../../../Learn/KnowledgeAssetContent/KnowledgeAssetContent";
    import KnowledgeAssetLoading
        from "../../../LoadingScreens/TopicOfInterestHomeLoading/KnowledgeAssetLoading/KnowledgeAssetLoading";
    import {mapActions} from "vuex";
    import ShowNotificationMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin";
    import TopicOfInterestHomeMap from "./TopicOfInterestHomeMap/TopicOfInterestHomeMap";
    import {FILTER_OPTIONS} from "@milestoneslabs/milestones-property-search/src/vue/classes/FilterDataValidations";
    import {PROPERTY_SEARCH_DISABLED_OPTION} from "../../../../../pages/LandingPage/Buy/Buy";
    import PropertyMapMixin from "../../../../../Mixins/PropertyMapMixin";

    export default {
        name: "TopicOfInterestHome",
        components: {TopicOfInterestHomeMap, KnowledgeAssetLoading, KnowledgeAssetContent, HomeFooter},

        mixins: [ShowNotificationMixin, PropertyMapMixin],

        data() {
            return {
                hasPropertyListings: window.hasPropertyListings,
                knowledgeAssetSearch: new AppResourceSearch('Knowledge-Asset'),
                topicOfInterest: this.landingPage.home.topicOfInterest,
                mapInitializing: true,
            };
        },

        computed: {
            asset() {
                return this.knowledgeAssetSearch.appResourceCollection.isNotEmpty
                    ? this.knowledgeAssetSearch.appResourceCollection.getFirst()
                    : new KnowledgeAssetAppResource({});
            },

            hasTitleAbove() {
                if (this.asset && this.asset.exists) {
                    return this.asset.type === 'knowledge-asset-video';
                }

                return false;
            }
        },

        methods: {
            ...mapActions([
                'setDefaultMlsAbbreviation',
                'setDefaultMapCoordinates',
            ]),

            async fetchAsset() {
                await this.knowledgeAssetSearch.setSearchData({
                    include: ['files', 'tags'],
                    filter: new ApiFilter({
                        params: {
                            uuid: this.landingPage.home.topicOfInterest.knowledgeAssetUuid,
                        }
                    }),
                }, false);

                await this.knowledgeAssetSearch.search();
            },

            initFilter() {
                if (this.topicOfInterest.filters) {
                    this.filter.clear();

                    let tempFilter;
                    let filterKeys = Object.values(FILTER_OPTIONS);
                    let filters = this.topicOfInterest.filters;

                    for (let key of filterKeys) {
                        if (filters.hasOwnProperty(key)) {
                            tempFilter = filters[key];

                            if (
                                key === FILTER_OPTIONS.SEARCH &&
                                filters[key].field &&
                                filters[key].label &&
                                filters[key].value
                            ) {
                                tempFilter = {
                                    nested: filters[key].field,
                                    value: filters[key].value,
                                };
                                this.filter.searchLabel = filters[key].label;
                            }

                            this.filter[key] = tempFilter;
                        }
                    }
                }
            },

            async initMap() {
                await this.fetchBuySection();
                this.mapInitializing = false;
            }
        },

        async beforeMount() {
            this.$bus.$on(PROPERTY_SEARCH_DISABLED_OPTION, this.handleDisabledOption);

            if (this.hasPropertyListings) {
                await this.initMap();
            }

            await Promise.all([
                this.fetchAsset(),
                this.fetchHomePurchaseProjectType(),

                this.initFilter(),
            ]);
        },

        beforeDestroy() {
            this.$bus.$off(PROPERTY_SEARCH_DISABLED_OPTION, this.handleDisabledOption);
        },
    };
</script>
